import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Transport from "@ledgerhq/hw-transport-webhid";

// Import the local package using dynamic import
let AppIcx;
const loadAppIcx = async () => {
  if (!AppIcx) {
    const module = await import("../../packages/hw-app-icx/lib/Icx.js");
    AppIcx = module.default;
  }
  return AppIcx;
};

import { ICONEX, LEDGER } from "src/constants/images";
import Modal from "./Modal";
import LedgerWalletAddressModal from "components/Modals/LedgerWalletAddressModal";
import {
  fetchWalletSuccess,
  detectMarketPlaceApproved,
  fetchWalletPath,
} from "../../redux/actions/wallet";
import * as icon from "services/icon";
import LeadgerLoadingModal from "./LedgerLoadingModal";
import ConnectWalletModal from "./ConnectWalletModal";

const BASE_PATH = `44'/4801368'/0'/0'`;

const ConnectionOptionModal = ({ onClose, isVisible, iconexConnection }) => {
  const [walletConnection, setWalletConnection] = useState(false);

  const address = useSelector((state) => state.wallet.walletAddress);

  const [isConnecting, setIsConnecting] = useState(false);
  const [icx, setIcx] = useState(null);
  const [transport, setTransport] = useState(null);
  const [wallets, setWallets] = useState([]);
  const [walletPaths, setWalletPaths] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [hasLedgerSupport, setHasLedgerSupport] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [error, setError] = useState(null);
  const [toaster, setToaster] = useState(false);
  const [loader, setLoader] = useState(false);

  const addressPerPage = 8;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isConnected && hasLedgerSupport) {
      loadAddresses(false, icx);
    }
  }, [currPage]);

  const loadAddresses = async (suppressError, icx) => {
    let i = 0;
    let counter;
    const addresses = [];
    const paths = [];

    while (i < addressPerPage) {
      try {
        suppressError = true;
        counter = (currPage - 1) * addressPerPage + i;
        const path = `${BASE_PATH}/${counter}'`;

        let { address } = await icx.getAddress(path, false, true);

        // let { address } = await icx.getAddress(path);

        address = address.toString();
        // const availableBalance = await getBalance(address);
        // const { staked, unstaking } = await getStake(address);
        // const balance = availableBalance.plus(staked).plus(unstaking || 0);
        addresses.push(address);
        paths.push(path);
      } catch (error) {
        setError(
          error?.message ? error.message : "loadin of wallet address failed!"
        );
      }

      i++;
    }

    setWallets(addresses);
    setWalletPaths(paths);
  };

  const connectToLedger = () => {
    let suppressError = false;

    setIsConnecting(true);

    Transport.create()
      .then(async (transport) => {
        transport.setDebugMode(false);
        setTransport(transport);
        const AppIcxClass = await loadAppIcx();
        const icx = new AppIcxClass(transport);

        setIcx(icx);

        try {
          //test if its working first
          setIsConnected(true);
          await icx.getAddress(`${BASE_PATH}/0'`, false, true);

          //our func here
          await loadAddresses(suppressError, icx);

          setIsConnecting(false);
        } catch (error) {
          if (suppressError)
            setError(
              error?.message ? error.message : "Failed connecting to Ledger."
            );
          else {
            setError(
              error?.message
                ? error.message
                : "transport channel could not be established!"
            );
          }
          setIsConnected(false);
          setIsConnecting(false);
        }
      })
      .catch((error) => {
        setError(
          error?.message
            ? error.message
            : "transport channel could not be established!"
        );
        setHasLedgerSupport(false);
        setIsConnecting(false);
      });
  };

  useEffect(() => {
    if (isConnected && hasLedgerSupport) {
      loadAddresses(false, icx);
    }
  }, [currPage]);

  const handleConfirmation = async (selectedWallet, path) => {
    dispatch(fetchWalletSuccess(selectedWallet, "ledger"));
    dispatch(fetchWalletPath(path, transport));
    const approval = await icon.checkIfMarketPlaceIsApproved(selectedWallet);
    dispatch(detectMarketPlaceApproved(approval));

    setLoader(true);
    setCurrPage(1);
  };

  const onNext = () => {
    setCurrPage((prev) => prev + 1);
  };

  const onPrevious = () => {
    setCurrPage((prev) => prev - 1);
  };

  const firstPage = () => {
    setCurrPage(1);
  };

  const toasterHide = () => {
    setToaster(true);
    setTimeout(() => {
      setToaster(false);
    }, 3000);
  };

  const handleClose = () => {
    setWalletConnection(false);
    setCurrPage(1);
  };

  useEffect(() => {
    if (wallets.length && !address) {
      setWalletConnection(true);
    }
  }, [wallets]);

  useEffect(() => {
    if (error) {
      toasterHide();
    }
  }, [error]);

  return (
    <>
      <Modal
        isVisible={isVisible}
        overlayClass="overlay"
        className="connect-modal connect-option d-flex flex-column  card px-3 py-4"
      >
        <div className="heading ">
          <h5 className="align-self-center title pb-0">Connect with:</h5>
        </div>
        <div className="body d-flex my-3 justify-content-center">
          <span
            tabIndex={0}
            onKeyPress={(e) => {
              if (e.code == "Enter") {
                onClose();
                iconexConnection();
              }
            }}
            onClick={() => {
              onClose();
              iconexConnection();
            }}
            className=" btn iconex-button mx-2 px-4 py-2"
          >
            <img src={ICONEX.SOURCE} alt="ledger" className="mb-1" />
            <p className="mt-1">ICONex</p>
          </span>
          <div className="d-flex flex-column align-items-center justify-content-between">
            <hr className="seperated-line h-100 m-0" />
            <p>or</p>
            <hr className="seperated-line h-100 m-0" />
          </div>
          <span
            tabIndex={0}
            onKeyPress={(e) => {
              if (e.code == "Enter") {
                onClose();
                connectToLedger();
              }
            }}
            onClick={() => {
              //onNext();
              onClose();
              connectToLedger();
            }}
            className=" btn ledger-button mx-2 px-4 py-2"
          >
            <img src={LEDGER.SOURCE} alt="ledger" className="mb-1 filterBg" />
            <p className="mt-1">Ledger</p>
          </span>
        </div>
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-outline-secondary cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <LedgerWalletAddressModal
        isVisible={walletConnection}
        onClose={handleClose}
        onConfirm={handleConfirmation}
        onNext={onNext}
        onPrevious={onPrevious}
        firstPage={firstPage}
        currentPage={currPage}
        addressList={wallets}
        walletPaths={walletPaths}
      />
      <LeadgerLoadingModal isVisible={isConnecting} />
      <ConnectWalletModal
        isVisible={loader}
        response={{ status: "success" }}
        onClick={() => setLoader(false)}
        ledger
      />
      {toaster ? (
        <div
          className="alert connection-alert alert-danger position-fixed py-2 toaster"
          role="alert"
        >
          {error}!
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default ConnectionOptionModal;
